/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Returntemperaturesecs4Inputs */



/**
* | output |
* | --- |
* | "ECS return temperatures" |
*
* @param {Br_History_Key_Returntemperaturesecs4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_returntemperaturesecs4 = /** @type {((inputs?: Br_History_Key_Returntemperaturesecs4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Returntemperaturesecs4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ECS return temperatures")
	return /** @type {LocalizedString} */ ("Températures de retour ECS")
});
export { br_history_key_returntemperaturesecs4 as "br_history_key_returnTemperaturesECS" }